/**
 * In-app Live Message Feed page (`/workspaces/:workspaceId/live-feed`).
 *
 * Renders the prototype Live Message Feed inside the authenticated app shell,
 * alongside the Tasks page. The feed runs entirely on demo data (`boards.ts`);
 * the per-driver message history and active context open as right-side overlays
 * within the feed itself. Reached from the left-nav "Live Feed" button.
 */

import Box from "@mui/material/Box";
import Snackbar from "@mui/material/Snackbar";
import { useState } from "react";

import { zinc } from "../colors";
import { LiveMessageFeedView } from "../LiveMessageFeedView";
import type { TaskState } from "../types";

export default function LiveFeedPage() {
  const [toast, setToast] = useState<string | null>(null);
  const [resolved] = useState<Record<string, TaskState>>({});

  return (
    // The new-design content area is `position: relative` with no definite height,
    // so fill it absolutely — a `height: 100%` chain collapses and clips the feed.
    <Box
      sx={{
        position: "absolute",
        inset: 0,
        display: "flex",
        flexDirection: "column",
        bgcolor: zinc[950],
        minHeight: 0,
      }}
    >
      <Box sx={{ flex: 1, minHeight: 0 }}>
        <LiveMessageFeedView resolved={resolved} onToast={setToast} />
      </Box>
      <Snackbar
        open={toast !== null}
        autoHideDuration={2600}
        onClose={() => setToast(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        message={toast ?? ""}
      />
    </Box>
  );
}
